import React, { useEffect, useState } from 'react';
import { getInvoices, createInvoice, markInvoicePaid, sendInvoice } from '../utils/api';
import { PageTitle, Card, Table, Btn, Input, Loading, Empty, statusBadge, Grid, StatCard } from '../components/UI';

export default function Invoices() {
  const [data, setData] = useState({ stats: {}, invoices: [] });
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ clientName: '', clientPhone: '', serviceFee: '', adSpend: '', notes: '' });
  const [acting, setActing] = useState(null);
const load = () => getInvoices()
  .then(r => {
    const result = r.data?.data || {};
    setData({
      stats: result.stats || {},
      invoices: Array.isArray(result.invoices) ? result.invoices : Object.values(result.invoices || {}),
    });
  })
  .catch(console.error)
  .finally(() => setLoading(false));
  
  useEffect(() => { load(); }, []);

  const handleGenerate = async () => {
    if (!form.clientName) return alert('Client name required');
    await createInvoice({
      ...form,
      serviceFee: Number(form.serviceFee),
      adSpend: Number(form.adSpend),
      items: [],
    }).catch(console.error);
    setForm({ clientName: '', clientPhone: '', serviceFee: '', adSpend: '', notes: '' });
    load();
  };

  const handlePaid = async (id) => {
    setActing(id);
    await markInvoicePaid(id).catch(console.error);
    await load();
    setActing(null);
  };

  const handleSend = async (id) => {
    setActing(id + 's');
    await sendInvoice(id).catch(e => alert(e.response?.data?.message || 'Failed'));
    setActing(null);
  };

  const s = data.stats || {};

  return (
    <div>
      <PageTitle title="🧾 Invoices" sub="Client invoices এবং payments" />
      <Grid cols={4}>
        <StatCard label="Total" value={s.total || 0} color="#a29bfe" />
        <StatCard label="Pending" value={s.pending || 0} color="#ffd200" />
        <StatCard label="Paid" value={s.paid || 0} color="#55efc4" />
        <StatCard label="Revenue" value={`৳${(s.totalRevenue || 0).toLocaleString()}`} color="#f7971e" />
      </Grid>

      <Card>
        <div style={{ fontWeight: 700, marginBottom: 16 }}>নতুন Invoice Generate করো</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
          <Input label="Client Name *" value={form.clientName} onChange={e => setForm({ ...form, clientName: e.target.value })} />
          <Input label="Client Phone" value={form.clientPhone} onChange={e => setForm({ ...form, clientPhone: e.target.value })} placeholder="01XXXXXXXXX" />
          <Input label="Service Fee (BDT)" value={form.serviceFee} onChange={e => setForm({ ...form, serviceFee: e.target.value })} type="number" />
          <Input label="Ad Spend (BDT)" value={form.adSpend} onChange={e => setForm({ ...form, adSpend: e.target.value })} type="number" />
          <Input label="Notes" value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })} />
        </div>
        <Btn onClick={handleGenerate}>🧾 Generate Invoice</Btn>
      </Card>

      <Card>
        {loading ? <Loading /> : (data.invoices || []).length === 0 ? <Empty msg="কোনো invoice নেই" /> : (
          <Table
            headers={['Invoice #', 'Client', 'Total', 'Due Date', 'Status', 'Actions']}
            rows={(data.invoices || []).map((inv, i) => (
              <tr key={i}>
                <td style={{ padding: '12px 16px', borderBottom: '1px solid #1e1e2e', fontSize: 12, color: '#6b6b80' }}>{inv.invoiceNumber}</td>
                <td style={{ padding: '12px 16px', borderBottom: '1px solid #1e1e2e' }}>
                  <div style={{ fontWeight: 600, fontSize: 14 }}>{inv.clientName}</div>
                  <div style={{ fontSize: 11, color: '#6b6b80' }}>{inv.clientPhone}</div>
                </td>
                <td style={{ padding: '12px 16px', borderBottom: '1px solid #1e1e2e', fontWeight: 700, color: '#a29bfe' }}>৳{inv.total?.toLocaleString()}</td>
                <td style={{ padding: '12px 16px', borderBottom: '1px solid #1e1e2e', fontSize: 12, color: '#6b6b80' }}>{new Date(inv.dueDate).toLocaleDateString('bn-BD')}</td>
                <td style={{ padding: '12px 16px', borderBottom: '1px solid #1e1e2e' }}>{statusBadge(inv.status)}</td>
                <td style={{ padding: '12px 16px', borderBottom: '1px solid #1e1e2e', display: 'flex', gap: 8 }}>
                  {inv.status === 'PENDING' && (
                    <Btn color="#55efc4" disabled={acting === inv.id} onClick={() => handlePaid(inv.id)} style={{ fontSize: 11, padding: '5px 10px' }}>✅ Paid</Btn>
                  )}
                  <Btn color="#74b9ff" disabled={acting === inv.id + 's'} onClick={() => handleSend(inv.id)} style={{ fontSize: 11, padding: '5px 10px' }}>📱 Send</Btn>
                </td>
              </tr>
            ))}
          />
        )}
      </Card>
    </div>
  );
}
